/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasSchema } from '../../openapi/models/OasSchema';

/**
 * A command used to add a new definition in a document.  Source for the new
 * definition must be provided.  This source will be converted to an OAS
 * definition object and then added to the data model.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class AddSchemaDefinitionCommand extends AbstractCommand {
    public _defExisted : boolean;

    public _newDefinitionName : string;

    public _newDefinitionObj : any;

    public constructor(definitionName? : any, obj? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((obj != null) || obj === null)) {
            let __args = arguments;
            super();
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionObj = obj;
            })();
        } else if(((typeof definitionName === 'string') || definitionName === null) && obj === undefined) {
            let __args = arguments;
            super();
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            (() => {
                this._newDefinitionName = definitionName;
            })();
        } else if(definitionName === undefined && obj === undefined) {
            let __args = arguments;
            super();
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddSchemaDefinitionCommand] Executing.");
        let doc : OasDocument = <OasDocument>document;
        if(this.defExists(doc)) {
            LoggerCompat.info("[AddSchemaDefinitionCommand] Definition with name %s already exists.", this._newDefinitionName);
            this._defExisted = true;
            return;
        }
        this.prepareDocumentForDef(doc);
        let definition : OasSchema = this.createSchemaDefinition(doc);
        this.addDefinition(doc, definition);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddSchemaDefinitionCommand] Reverting.");
        if(this._defExisted) {
            return;
        }
        let doc : OasDocument = <OasDocument>document;
        this.removeDefinition(doc);
    }

    abstract defExists(document : OasDocument) : boolean;

    abstract prepareDocumentForDef(document : OasDocument);

    abstract createSchemaDefinition(document : OasDocument) : OasSchema;

    abstract addDefinition(document : OasDocument, definition : OasSchema);

    abstract removeDefinition(document : OasDocument);
}
AddSchemaDefinitionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand";
AddSchemaDefinitionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

